<template lang="pug" src="./block-testimonial.pug"></template>

<script>
import ArrowLeft from 'templates/arrow-left.icon.html'
import ArrowRight from 'templates/arrow-right.icon.html'
import Icon from 'components/icon/icon'

export default {
  data () {
    return {
      'arrowLeft': ArrowLeft,
      'arrowRight': ArrowRight
    }
  },
  props: ['props'],
  computed: {
    app () {
      return this.$store.state.app.information
    }
  },
  components: {
    Icon
  }
}
</script>



// WEBPACK FOOTER //
// block-testimonial.vue?32ab6254